import { getRequest } from '../utils'

export const getDefaultPlanTemplate: RequestTypeVariable = {
  getKey: (
    planType: PlanTemplateType,
    paperFormat: PlanTemplatePaperFormat,
    orientation: PlanTemplateOrientation,
  ) => ['getDefaultPlanTemplate', planType, paperFormat, orientation],
  request: async (
    planType: PlanTemplateType,
    paperFormat: PlanTemplatePaperFormat,
    orientation: PlanTemplateOrientation,
  ): Promise<Blob> => {
    const { data } = await getRequest<Blob>({
      url: '/plan-templates/default-template',
      params: {
        plan_type: planType,
        paper_format: paperFormat,
        orientation,
        // Cache buster: unique per request so browsers never serve a stale template
        t: Date.now(),
      },
      responseType: 'blob',
    })

    return data as Blob
  },
}

export const getDefaultDocumentationTemplate: RequestTypeVariable = {
  getKey: (documentType: DocumentationTemplateType) => [
    'getDefaultDocumentationTemplate',
    documentType,
  ],
  request: async (documentType: DocumentationTemplateType): Promise<Blob> => {
    const { data } = await getRequest<Blob>({
      url: '/plan-templates/default-documentation-template',
      params: {
        document_type: documentType,
        // Cache buster: unique per request so browsers never serve a stale template
        t: Date.now(),
      },
      responseType: 'blob',
    })

    return data as Blob
  },
}
